import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelationshipComponent } from './relationship/relationship.component';
import { IndividualsComponent } from './individuals/individuals.component';
import { DropMenuModule } from '../drop-menu/drop-menu.module';
import { MediaGalleryModule } from '../media-gallery/media-gallery.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { IndividualMainComponent } from './individual-main/individual-main.component';
import { IndividualAdderComponent} from './individual-adder/individual-adder.component';


@NgModule({
  declarations: [ RelationshipComponent, IndividualsComponent, IndividualMainComponent,IndividualAdderComponent],
  imports: [
    CommonModule,
    DropMenuModule,
    MediaGalleryModule,
    FormsModule,
    SharedModule
  ],
  exports : [ RelationshipComponent, IndividualsComponent, IndividualMainComponent, IndividualAdderComponent]
})
export class IndividualModule { }

// translation loader moved to SharedModule
